import { createGtm } from "@gtm-support/vue-gtm"
import { LOCALE } from "~/constants/locale"

export default defineNuxtPlugin(nuxtApp => {
  if (import.meta.client) {
    const config = useRuntimeConfig()
    const locale = nuxtApp.$i18n.locale.value

    const gtmIdMap: Record<string, string | undefined> = {
      [LOCALE.ES]: config.public.gtm.id_es,
      [LOCALE.US]: config.public.gtm.id_us,
      [LOCALE.FR]: config.public.gtm.id_fr,
      [LOCALE.DE]: config.public.gtm.id_de,
    }

    const gtmId = gtmIdMap[locale] ?? config.public.gtm.id

    nuxtApp.vueApp.use(
      createGtm({
        id: gtmId || "GTM-XXXXXX",
        enabled: Boolean(gtmId) || config.public.gtm.debug === "true",
        debug: config.public.GOOGLE_TAG_MANAGER_DEBUG === "true",
        defer: true
      })
    )
  }
})
